import React from "react";
import Loader from "react-loader-spinner";

const WithSpinner = () => {
  return (
    <div className="loader mySpinner">
      <Loader type="Oval" color="#0F9ED1" height={100} width={100} />
      <p style={{ color: "#ccc", width: "200px" }}>Loading Page...</p>
    </div>
  );
};

export default WithSpinner;

// const WithSpinner = (ComponentToRender) => ({ isLoading, ...otherProps }) => {
//   return isLoading ? (
//     <div className="mySpinner">
//       <Loader type="Oval" color="#D02B87" />
//     </div>
//   ) : (
//     <ComponentToRender {...otherProps} />
//   );
// };
